import uniqueId from '@form-create/utils/lib/unique';
import { makeRequiredRule } from '../../utils';
var label = '日期时间';
var name = 'datePicker';
export default {
  icon: 'iconfont iconriqishijian1',
  label: label,
  name: 'datetimerange',
  rule: function rule() {
    return {
      type: name,
      field: uniqueId(),
      title: label,
      info: '',
      props: {
        type: 'datetime'
      }
    };
  },
  props: function props() {
    return [makeRequiredRule()];
  },
  basic: function basic() {}
};